import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-reset-password-dialogue',
    templateUrl: './reset-password-dialogue.component.html',
    styleUrls: ['./reset-password-dialogue.component.scss'],
    standalone: false
})
export class ResetPasswordDialogueComponent {

  alternativeEmail;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ResetPasswordDialogueComponent>,
  ) {
  }

  closeDialog() {
    this.dialogRef.close(this.alternativeEmail);
  }

  save() {
    this.dialogRef.close({
      choice: true,
      email: this.alternativeEmail,
    });
  }

}
